import styled from '@emotion/styled';

export const DashboardContent = styled('div', { label: 'DashboardContent' })`
    position: absolute;
    background: #fff;
    margin: 0;
    padding: 0;
    left: 248px;
    height: calc(100vh - 58px);
    width: calc(100vw - 248px);
`;

